import styled from 'styled-components'

export const Container = styled.div`
	position: fixed;
	inset: 0;
	z-index: 9999;
	width: 100%;
	height: 100vh;
	min-height: 100dvh;
	padding: ${({ isFullHeight }) => (isFullHeight ? '0px' : '30px')};
	display: flex;
	justify-content: center;
	align-items: ${({ isFullHeight }) => (isFullHeight ? 'flex-end' : 'center')};
	background: ${props => props.theme.colors.greys.modalOverlay};
`

export const Content = styled.div`
	height: ${({ isFullHeight, customHeight }) => (isFullHeight ? '95%' : customHeight || 'auto')};
	width: ${({ isFullHeight, widthDesktop }) => (isFullHeight ? '100%' : widthDesktop || 'auto')};
	max-width: ${({ isFullHeight, widthDesktop }) => (isFullHeight ? '100%' : widthDesktop || '430px')};
	position: relative;
	background-color: ${props => props.theme.colors.brand.white};
	border-radius: 12px;
	padding: 24px;
`

export const CloseButton = styled.button`
	position: absolute;
	top: 12px;
	right: 12px;
	width: 32px;
	height: 32px;
	border: none;
	background: transparent;
	color: ${props => props.theme.colors.text.primaryText};
	display: flex;
	align-items: center;
	justify-content: center;
	line-height: 1;
	cursor: pointer;
	z-index: 1;
	padding: 0;
`

export const ModalContainer = styled.div`
	display: flex;
	text-align: center;
	flex-direction: column;
	padding: 20px;
	color: ${props => props.theme.colors.green};

	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		width: 100%;
		min-width: 350px;
		max-width: ${props => props.theme.sizes.breakPoints.tiny};
	}
`

export const ActionContainer = styled.div`
	margin-top: 30px;
	width: 100%;

	> button:first-child {
		margin-bottom: 10px;
	}

	@media (min-width: ${props => props.theme.sizes.breakPoints.small}) {
		display: flex;
		width: 370px;
		margin-left: auto;
		margin-right: auto;
	}
`

export const ComponentContainer = styled.div`
	display: flex;
	text-align: center;
	flex-direction: column;
	align-items: ${({ $alignItems = 'flex-end' }) => $alignItems};
	justify-content: ${({ isFullHeight }) => (isFullHeight ? 'space-between' : 'flex-start')};
	padding: ${({ $padding = '70px 20px 50px 20px' }) => $padding};
	font-size: 24px;
	background: ${props => props.theme.colors.brand.white};
	width: 100%;
	border-radius: ${({ isFullHeight }) => isFullHeight ? '25px 25px 0 0' : '25px'};
	gap: ${({ $gap = '14px' }) => $gap};
	height: ${({ $height, isFullHeight }) => $height || (isFullHeight ? '100%' : 'auto')};
	min-height: ${({ $minHeight = 'auto' }) => $minHeight};
	max-height: ${({ $maxHeight = 'none' }) => $maxHeight};
	@media (min-width: ${props => props.theme.sizes.breakPoints.small}) {
		display: flex;
		padding: ${({ $paddingDesktop, $padding = '70px 20px 50px 20px' }) =>
			$paddingDesktop || $padding};
		gap: ${({ $gapDesktop, $gap = '14px' }) => $gapDesktop || $gap};
		text-align: center;
		flex-direction: column;
		align-items: ${({ $alignItems = 'flex-end' }) => $alignItems};
	}
`

export const TitleContainer = styled.div`
	width: 100%;
	display: flex;
	justify-content: ${({ $titleAlign = 'flex-start' }) => {
		switch ($titleAlign) {
			case 'center':
				return 'center'
			case 'right':
				return 'flex-end'
			default:
				return 'flex-start'
		}
	}};
`

export const ModalTitle = styled.div`
	width: 100%;
	color: ${props => props.theme.colors.text.primaryText};
	font-size: 24px;
	font-weight: 600;
	text-align: ${({ $titleAlign = 'left' }) => $titleAlign};
`

export const ModalMainSection = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: ${({ $gap = '16px' }) => $gap};
	${({ $grow }) =>
		$grow &&
		`
		flex: 1;
		min-height: 0;
	`}
`

export const ButtonsContainer = styled.div`
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	max-width: ${({ maxWidth }) => maxWidth || '600px'};
`
